import { StyleSheet, ViewStyle } from "react-native";

interface LoginStyles {
  textInputContainer: ViewStyle;
  linkContainer: ViewStyle;
}

export const loginStyles = StyleSheet.create<LoginStyles>({
  textInputContainer: {
    flex: 1,
    justifyContent: "space-evenly",
    marginHorizontal: 10,
  },
  linkContainer: {
    alignItems: "center",
    justifyContent: "space-evenly",
    marginTop: 20,
  },
});
